import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bold",
  "use": "icon-bold-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-bold\"><path d=\"M16.645 11.3A4.675 4.675 0 0018 8.017v-.25C18 5.136 15.797 3 13.082 3H5.685C5.308 3 5 3.3 5 3.67v16.608c0 .4.33.722.737.722h7.968C16.63 21 19 18.696 19 15.852v-.27c0-1.784-.935-3.357-2.355-4.282zM7.4 5.348h5.617c1.428 0 2.583 1.086 2.583 2.428v.233c0 1.34-1.157 2.428-2.582 2.428H7.4v-5.09zm9.165 10.502c0 1.538-1.293 2.785-2.888 2.785H7.4V12.8h6.277c1.596 0 2.888 1.247 2.888 2.785v.264z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol